<template>
    <div>
        <div class="cost-container">
            <eos :venueId="venueId" />
        </div>
    </div>
</template>

<script>
import eos from '@/components/eos/index'
export default {
    name: 'shiftConfiguration',
    components: {
        eos
    },
    data () {
        return {
            venueId: this.$route.params.id
        }
    }
}
</script>

<style lang="scss" scoped>
.cost-container{
  width: 100%;
  background: #2B3444;
  box-sizing: border-box;
  padding: 50px 30px 30px 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/account/shiftConfiguration/index.vue